<template>
<modal
	class="withdraw-modal"
	size="medium"
	@close="closeModal">
	<template slot="header">
		<h3>{{ $t('Processing WD') }}</h3>
	</template>
	<template slot="body">
		<p>{{ $t('Are you sure want to process') }}</p>
		<p class="text-bold">"{{ history.description }}"?</p>
	</template>
	<template slot="footer">
		<!-- Cancel -->
		<button
			type="button"
			class="btn btn-light"
			@click="closeModal">
			{{ $t('No') }}
		</button>
		<!-- Submit -->
		<button
			class="btn btn-success"
			:class="{ 'is-loading': isProcessing }"
			@click="process">
			<span>{{ $t('Yes') }}</span>
		</button>
	</template>
	</modal>
</template>

<script>
import Modal from '@/components/Modal.vue';

export default {
	name: 'ProcessModal',
	components: {
		Modal,
	},
	props: {
		history: {
			type: Object,
			required: true,
		},
		isProcessing: {
			type: Boolean,
			default: false,
		},
	},
	methods: {
		closeModal() {
			this.$emit('close');
		},
		process() {
			this.$emit('process');
		},
	},
};
</script>
